require('./RAAlertsWidget.scss');

// @vendors
const React = require('react');
const PropTypes = require('prop-types');
const moment = require('moment');

// @utilites
const { formatText, FormattedText } = require('core/i18n').i18n;
const { toCamelCase } = require('utilities/stringHelper');

// @commons
const { LoadingSection } = require('commonsComponents/loadingSection');
const { EmptyState } = require('commonsComponents/emptyState');
const { OKLink } = require('commonsComponents/OKLink');

// @constants
const { DATE_FORMAT } = require('../../raConstants/index');
const {
    DATE_FORMAT_SHORT_TIME_24,
    DATE_FORMAT_SLASHED_ES,
    DATE_FORMAT_SLASHES_SHORT_DAY_MONTH_YEAR,
} = require('constants/index');

class RAAlertsWidget extends React.Component {
    componentDidMount() {
        this.props.fetchAlerts();
    }

    render() {
        const {
            immAlertsData,
            textLink,
            isInfoFromPoe,
            url,
            linkTaggingEvent,
        } = this.props;
        const error = immAlertsData.get('error');
        const loading = immAlertsData.get('loading');
        const alerts = immAlertsData.get('alerts');

        let content;
        if (loading) {
            content = <LoadingSection />;
        } else if (error || alerts.size === 0) {
            content = (
                <div className="ra-alerts-widget__empty-state">
                    <EmptyState
                        primaryText=""
                        secondaryText={formatText('raAlertsWidget-emptyText')}
                        iconType="alert-wealth"
                        withMargin={false}
                    />
                </div>
            );
        } else {
            const notificationsContent = alerts
                .slice(0, 2)
                .map((alert, index) => {
                    const description = alert.get('message');
                    const alertDate = alert.get('createdOn');
                    const dateAndTime = moment(
                        alertDate,
                        DATE_FORMAT_SLASHED_ES,
                    );
                    let date, time;
                    if (dateAndTime.isValid()) {
                        date = toCamelCase(dateAndTime.format(DATE_FORMAT));
                        time = dateAndTime.format(DATE_FORMAT_SHORT_TIME_24);
                    } else if (alertDate) {
                        date = toCamelCase(
                            moment(
                                alertDate.split(' ')[0],
                                DATE_FORMAT_SLASHES_SHORT_DAY_MONTH_YEAR,
                            ).format(DATE_FORMAT),
                        );
                        time = moment(
                            alertDate.split(' ')[1],
                            DATE_FORMAT_SHORT_TIME_24,
                        ).format(DATE_FORMAT_SHORT_TIME_24);
                    }

                    return (
                        <li key={index} className="ra-alerts-widget__alert">
                            <header className="ra-alerts-widget__alert-header clearfix">
                                {!isInfoFromPoe && (
                                    <i className="icon icon-bookmark ra-alerts-widget__bookmark-icon pull-left" />
                                )}
                                <span className="ra-alerts-widget__date pull-left">
                                    {date}
                                </span>
                                <span className="ra-alerts-widget__time pull-left">
                                    {time}
                                </span>
                            </header>
                            {description}
                        </li>
                    );
                });
            content = (
                <div className="row">
                    <div className={isInfoFromPoe ? 'col-xs-12' : 'col-xs-9'}>
                        <ul className="ra-alerts-widget__alert-list">
                            {notificationsContent}
                        </ul>
                    </div>
                    {!isInfoFromPoe && (
                        <div className="col-xs-3">
                            <i className="ra-alerts-widget__bell-icon" />
                        </div>
                    )}
                </div>
            );
        }

        return (
            <section className="ra-alerts-widget">
                <h3 className="ra-alerts-widget__title">
                    <FormattedText value="raAlertsWidget-title" />
                </h3>
                {content}
                {isInfoFromPoe && (
                    <OKLink
                        modifier="complementary"
                        to={url}
                        target="_blank"
                        onClick={!!linkTaggingEvent && linkTaggingEvent}
                    >
                        {textLink}
                    </OKLink>
                )}
            </section>
        );
    }
}

RAAlertsWidget.propTypes = {
    immAlertsData: PropTypes.object.isRequired,
    fetchAlerts: PropTypes.func.isRequired,
    textLink: PropTypes.string,
    isInfoFromPoe: PropTypes.bool,
    url: PropTypes.string,
    linkTaggingEvent: PropTypes.func,
};
RAAlertsWidget.defaultProps = {
    isInfoFromPoe: false,
};
module.exports = RAAlertsWidget;
